// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Gl_Component from '@/utils/globalComponents';
import api from '@/api/api';
import util from '@/utils/util';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VueI18n from "vue-i18n";
import './utils/rem'
Vue.use(VueI18n);

const i18n = new VueI18n({
	// 默认语言
	locale: localStorage.getItem('language')||'zh-cn',
	// 引入语言文件
	messages: {
		'zh-cn': require('./lang/zh'),
		'en-us': require('./lang/en'),
	}
})

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(Gl_Component);
Vue.prototype.$util = util;
Vue.prototype.$api = api;

Vue.prototype.$vm = new Vue();

Vue.prototype.imgPath =  process.env.NODE_ENV === "production" ? "/wap" : ""

import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)

import filters from './utils/filter'
Object.keys(filters).forEach(key => {
	Vue.filter(key, filters[key])
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})
// 加入百度统计
router.beforeEach((to, from, next) => {
	if (to.path) {
		if (window._hmt) {
			window._hmt.push(['_trackPageview', '/#' + to.fullPath])
		}
	}
	next()
})



// WEBPACK FOOTER //
// ./src/main.js